import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { MuiStack } from "../../../components";
import { BackgroundPWSVG } from "../assets/assets";
var NoDocumentFound = function (props) {
    var Img = styled("img")(function (_ref) {
        var theme = _ref.theme;
        return {};
    });
    var title = props.title, paragraph = props.paragraph, height = props.height;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        height: height ? height : '100%',
        width: '100%',
        spacing: 2,
        padding: 2,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(BackgroundPWSVG, {
        color: "secondary",
        sx: {
            width: '250px',
            height: '200px',
            background: 'transparent'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "blankDocTitle",
        variant: "h1",
        sx: {
            textAlign: 'center',
            whiteSpace: 'nowrap'
        }
    }, title)), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "blankDocParagraph",
        variant: "h4",
        sx: {
            color: '#8593A3',
            textAlign: 'center'
        }
    }, paragraph)));
};
export default NoDocumentFound;
